import { getTestAttributes, slug } from '@chillibean/component-library';
import PropTypes from 'prop-types';

import { getFieldTitle } from '../../../__util__/field';

export function CheckboxField(props) {
  const {
    disabled,
    handleChange,
    handleBlur,
    handleClick,
    fieldRequired,
    fieldIdentifier = 'checkbox',
    fieldName,
    showError,
    errorMessage,
    checked,
    optionValue,
    optionText,
    fieldID = '',
  } = props;

  const handleOnChange = (event) => handleChange && handleChange(event, 'checkbox');
  const handleOnBlur = (event) => handleBlur && handleBlur(event, 'checkbox');
  const handleOnClick = (event) => handleClick && handleClick(event);

  return (
    <div className="form__field-wrapper form__options-grid-child">
      <div className="form__field form__field--checkbox">
        <input
          key={checked}
          type="checkbox"
          id={fieldID}
          name={fieldName}
          className="form__control form__control--checkbox"
          onClick={handleOnClick}
          onBlur={(event) => handleOnBlur(event)}
          onChange={(event) => handleOnChange(event)}
          disabled={disabled}
          value={optionValue}
          checked={checked}
        />
        <label htmlFor={fieldID} {...getTestAttributes(`${slug(`${optionValue}-${fieldIdentifier}`)}-form-field`)}>
          <span className="clickable-label">{getFieldTitle(fieldRequired, optionText)}</span>
        </label>
        {showError && (
          <div
            className="form__validation-error"
            {...getTestAttributes(`${slug(fieldIdentifier)}-form-field-error-message`)}
          >
            {errorMessage}
          </div>
        )}{' '}
      </div>
    </div>
  );
}

CheckboxField.propTypes = {
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleClick: PropTypes.func,
  fieldID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  optionValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  optionText: PropTypes.string,
  fieldIdentifier: PropTypes.string,
  fieldName: PropTypes.string,
  showError: PropTypes.bool,
  errorMessage: PropTypes.string,
  fieldRequired: PropTypes.bool,
  checked: PropTypes.bool,
};

export default CheckboxField;
